import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { useAppQuery } from '../use-app-query.hook';
import { DividendPayoutStatus } from './dividend.types';

export type DividendPayoutRow = {
  approvalDate: null | string;
  createdAt: string;
  dividendPerShare: null | number;
  filesLinks: null | string[];
  payoutDate: null | string;
  payoutId: string;
  payoutName: string;
  shareClassId: null | string;
  shareClassName: null | string;
  shares: null | number;
  stakeholderId: string;
  stakeholderName: string;
  status: DividendPayoutStatus;
  totalAmount: number;
};

type PayoutRowsResponse = { records: DividendPayoutRow[] };

type Props = {
  // The dividends API scopes to the session company (companies/:companyId is resolved server-side
  // from @UserInfo), so companyId only keys the cache — same contract as useDividendStakeholderRows.
  companyId: string;
  enabled?: boolean;
  payoutId: string;
  // Omitted by callers that need the whole payout at once — the details sheet sums its rows.
  skip?: number;
  take?: number;
};

export const useDividendPayoutRows = ({
  companyId,
  payoutId,
  enabled = true,
  skip,
  take,
}: Props) => {
  const { data: { records = [] } = {}, isLoading } = useAppQuery({
    queryKey: [QueryKey.DIVIDEND_PAYOUT_ROWS, companyId, payoutId, { skip, take }],
    queryFn: () =>
      ApiService.get<PayoutRowsResponse>(
        {
          endpoint: BackendRoute.DIVIDENDS,
          routePath: [payoutId, 'rows'],
        },
        { queryParams: { skip, take } },
      ),
    enabled: enabled && !!companyId && !!payoutId,
  });

  return { isLoading, records };
};
